import C from 'classnames';
import React, { useEffect, useState } from 'react';
import {
  Avatar,
  ButtonGroup,
  CardBody,
  CardHeader,
  Modal,
  ModalCard,
  ModalHeader,
  ModalTitle,
  Nav,
  NavBar,
  NavItem,
  NavLink,
  RadioButton,
  SearchForm,
} from '../..';
import { FileCard } from '../Cards';
import { IFileCardProps } from '../Cards/FileCard';

interface IMediaBrowserProps {
  isOpen: boolean;
  content: {
    [index: string]: {
      tagName: string;
      data: IFileCardProps[];
    };
  };
  fixedNav?: boolean;
  detailed?: boolean;
  setDetailed?: (detailed: boolean) => void;
  triggerShowMore?: () => void;
  onSearch?: (query?: string) => void;
  onSelect?: (data?: IFileCardProps) => void;
  toggle?: () => void;
  searchable?: boolean;
}

const MediaBrowser: React.FunctionComponent<IMediaBrowserProps> = (props) => {
  const [tagKey, setTagKey] = useState('');

  const selectTag = (tagkey: string) => {
    setTagKey(tagkey);
  };

  const onSelect = (data: IFileCardProps) => {
    props.onSelect && props.onSelect(data);
  };

  useEffect(() => {
    props.content && setTagKey(Object.keys(props.content).sort()[0]);
  }, [props.content]);

  return (
    <Modal isOpen={props.isOpen} size="lg" toggle={props.toggle}>
      <ModalCard className="overflow-hidden">
        <ModalHeader>
          <ModalTitle>Media Browser</ModalTitle>
          <ButtonGroup toggle>
            <RadioButton
              variant="light"
              size="sm"
              name="detailed"
              checked={!props.detailed}
              onClick={() => props.setDetailed && props.setDetailed(false)}
            >
              <i className="fe fe-grid"></i>
            </RadioButton>
            <RadioButton
              variant="light"
              size="sm"
              name="detailed"
              checked={!!props.detailed}
              onClick={() => props.setDetailed && props.setDetailed(true)}
            >
              <i className="fe fe-list"></i>
            </RadioButton>
          </ButtonGroup>
        </ModalHeader>
        {props.searchable && (
          <CardHeader>
            <SearchForm onSearch={props.onSearch} />
          </CardHeader>
        )}
        <CardBody
          className={C(
            'p-0 pb-2 ',
            props.fixedNav && 'modal-height-fixed py-0'
          )}
        >
          <div className={C('d-flex', props.fixedNav && 'h-100')}>
            {props.content && Object.keys(props.content).length > 1 && (
              <Nav widthAuto pills relative expand="xs">
                <NavBar className="px-2">
                  {props.content &&
                    tagKey &&
                    Object.keys(props.content)
                      .sort()
                      .map((key) => {
                        return (
                          <NavItem key={key}>
                            <NavLink
                              onClick={() => selectTag(key)}
                              active={tagKey === key}
                            >
                              <span className="fe fe-tag"></span>
                              <span>
                                {props.content[key] &&
                                  props.content[key].tagName}
                              </span>
                            </NavLink>
                          </NavItem>
                        );
                      })}
                </NavBar>
              </Nav>
            )}
            <div
              className={C('col', props.fixedNav && 'h-100 overflow-auto py-2')}
            >
              {props.detailed ? (
                props.content &&
                tagKey &&
                props.content[tagKey].data.map((val, i) => {
                  return (
                    <div
                      onClick={() => onSelect(val)}
                      key={tagKey + '-card' + i}
                    >
                      {val && <FileCard key={tagKey + i} {...val} size="xl" />}
                    </div>
                  );
                })
              ) : (
                <div className="d-flex flex-wrap flex-grow">
                  {props.content &&
                    tagKey &&
                    props.content[tagKey].data.map((val, i) => {
                      return (
                        <div
                          onClick={() => onSelect(val)}
                          key={tagKey + 'avatar-' + i}
                        >
                          {val && (
                            <Avatar
                              size="xxl"
                              className="m-2"
                              rounded
                              key={tagKey + i}
                              src={val.thumbnailUrl}
                            />
                          )}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </ModalCard>
    </Modal>
  );
};

export default MediaBrowser;
